var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 py-1"},[(_vm.item[_vm.column])?_c('div',{staticClass:"flex items-center justify-center h-6 w-6 rounded-full bg-white border border-green-300 text-green-700"},[_c('i',{staticClass:"fal fa-check"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }